"use strict";

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if (this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if (this.collection_style == 'slider') {
      this.createSlider();
    }
  },
  createSlider: function createSlider() {
    var get_slides_per_group = function get_slides_per_group() {
      return window.innerWidth < 799 ? 2 : window.innerWidth < 1025 ? 3 : 5;
    };

    var listen_screen_resize = function listen_screen_resize(sliderInstance) {
      var slides_per_group = get_slides_per_group();

      if (sliderInstance.options.groupCells !== slides_per_group) {
        sliderInstance.options.groupCells = slides_per_group;
        sliderInstance.resize();
        sliderInstance.reposition();
      }
    };

    var featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');
    var slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true,
      slides_per_group: get_slides_per_group()
    };
    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      groupCells: slideData.slides_per_group,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: slideData.wrapAround,
      pageDots: true,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function ready() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on('settle.flickity', function () {
            $(featuredCollectionSlider).flickity('resize');
          }); // Change flickity grouping and resize on brakepoint change

          this.listen_screen_resize = listen_screen_resize.bind(null, this);
          window.addEventListener('screenResized', this.listen_screen_resize);
        }
      }
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    window.removeEventListener('screenResized', $slider.listen_screen_resize);
    $slider.flickity('destroy');
  }
};